import React, { useState } from "react";

import { Code } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/src/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/src/components/ui/dialog";

import EmbedDialogBody from "./EmbedDialogBody";

import type { JSX } from "react";

import type { EmbeddedProps } from "./Embedded.types";

export default function Embedded({
  items,
  isVersion,
}: EmbeddedProps): JSX.Element {
  const { t } = useTranslation("editor-content");
  const [dialogContainer, setDialogContainer] = useState<HTMLElement | null>(
    null,
  );

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          className="bg-card text-foreground h-auto gap-[0.46875rem] rounded-[0.3125rem] p-[0.46875rem] font-normal drop-shadow"
          variant="ghost"
        >
          <Code className="size-6" />
          {t("embedded", { ns: "editor-utils" })}
        </Button>
      </DialogTrigger>
      <DialogContent ref={setDialogContainer}>
        <DialogHeader>
          <DialogTitle>{t("embedCode")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("embedDescription")}
          </DialogDescription>
        </DialogHeader>
        <EmbedDialogBody
          isVersion={isVersion}
          items={items}
          popoverContainer={dialogContainer}
        />
      </DialogContent>
    </Dialog>
  );
}
